//////////////////////////////////////////////////////
// Countdown timer logic used on all pages where a
// timer exists.
//////////////////////////////////////////////////////

function countDownTimer(timerID) {
  const timer = document.getElementById(timerID);
  const dateStart = timer.getAttribute("data-date-end");
  // Set the date we're counting down to
  var countDownDate = new Date(dateStart).getTime();

  // Update the count down every 1 second
  var x = setInterval(function () {
    // Get today's date and time
    var now = new Date().getTime();

    // Find the distance between now and the count down date
    var distance = countDownDate - now;

    // Time calculations for days, hours, minutes and seconds
    var days = Math.floor(distance / (1000 * 60 * 60 * 24));
    var hours = Math.floor(
      (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((distance % (1000 * 60)) / 1000);

    // Display the result in the element with id="demo"
    document.getElementById("countdown-timer-days").textContent = days + ":D";
    document.getElementById("countdown-timer-hours").textContent = hours + ":H";
    document.getElementById("countdown-timer-minutes").textContent =
      minutes + ":M";
    document.getElementById("countdown-timer-seconds").textContent =
      seconds + ":S";
    +minutes + "m " + seconds + "s ";

    // If the count down is finished, write some text
    if (distance < 0) {
      clearInterval(x);
      document.getElementById("countdown-timer-days").textContent = "0d ";
      document.getElementById("countdown-timer-hours").textContent = "0h ";
      document.getElementById("countdown-timer-minutes").textContent = "0m ";
      document.getElementById("countdown-timer-seconds").textContent = "0s ";
    }
  }, 1000);
}

// exports function to be used on other scripts
export default countDownTimer;
